module.exports = __webpack_public_path__ + "w.no1.a1c189b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/w.no1.jpg
// module id = QSho
// module chunks = 0